<template>
  <div class="contact-banner">
    <img :src="contactBanner" alt="" />
  </div>
</template>

<script>
import { reactive } from "vue";

import contactBanner from "../../../assets/contact/contactBanner.png";

export default {
  setup() {
    return reactive({
      contactBanner: contactBanner,
    });
  },
};
</script>

<style scoped>
@media screen and (max-width: 1180px) {
  .contact-banner {
    min-width: 1180px;
  }
}
.contact-banner img {
  width: 100%;
  height: 628px;
}
</style>
